// extracted by mini-css-extract-plugin
module.exports = {"chatDisplay":"ChatDisplay_chatDisplay__3DnEj","issueLabel":"ChatDisplay_issueLabel__HepZ3"};